
import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { Observable } from 'rxjs';
import { OptimizePlanRequest } from "../../domain";
import { PlansRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class OptimizePlanUsecase implements UseCase<OptimizePlanRequest, boolean> {

  constructor(private readonly planRepository: PlansRepository) {
  }

  execute(params: OptimizePlanRequest): Observable<boolean> {
    return this.planRepository.optimizePlan(params);
  }

}
